module.exports = __webpack_public_path__ + "static/inp-attribution-0d6a0e63fb8787ffe3888aa68cb09e4b.png";